interface ServiceIntroProps {
  onStart: () => void;
}

const WAVEFORM_BARS = [14, 22, 34, 18, 42, 26, 44, 16, 30, 12];

export default function ServiceIntro({ onStart }: ServiceIntroProps) {
  return (
    <div className="flex flex-col h-full px-6 py-8 bg-white animate-fade-in-up">
      {/* 상단 로고 */}
      <div className="flex justify-center pt-2">
        <img
          src="https://storage.helloreaddy.io/project_files/a1e21e58-82d2-4e64-8a34-d104a4996fee/26afe99a-88fc-4cd8-9b48-938ec47e0bca_compressed_spick-health_b.webp"
          alt="스픽-헬스 로고"
          className="h-10 w-auto object-contain"
        />
      </div>

      {/* 중앙 콘텐츠 */}
      <div className="flex-1 flex flex-col items-center justify-center w-full text-center">
        <h1 className="text-[28px] leading-tight font-bold text-foreground-900">
          목소리로 간편하게 확인하는
          <br />
          나의 인지건강
        </h1>

        <p className="text-[15px] leading-relaxed text-foreground-600 mt-4 max-w-[280px]">
          간단한 질문에 목소리로 답하면, 음성 기반 AI가 인지건강 상태를 분석해
          결과를 안내해드려요.
        </p>

        {/* 말풍선 + 음성 파형 */}
        <div className="relative mt-9">
          <div className="bg-primary-50 rounded-[28px] px-10 py-8 flex flex-col items-center">
            <div className="flex items-center justify-center gap-[3px] h-12">
              {WAVEFORM_BARS.map((h, i) => (
                <span
                  key={i}
                  className="waveform-bar w-1.5 rounded-full bg-primary-500"
                  style={{ height: `${h}px`, animationDelay: `${i * 0.09}s` }}
                />
              ))}
            </div>
          </div>
          <div className="absolute -bottom-2 left-12 w-5 h-5 bg-primary-50 rotate-45 rounded-sm" />
        </div>
      </div>

      {/* 의료적 안내 + CTA */}
      <div className="w-full pt-2 pb-1">
        <div className="w-full bg-primary-50 rounded-xl px-4 py-3 flex items-start gap-2">
          <i className="ri-information-line text-primary-600 text-base leading-none mt-[1px] shrink-0" />
          <p className="text-[12px] leading-relaxed text-foreground-600">
            본 서비스는 인지건강 상태 확인을 위한 참고용 서비스이며, 의료적 진단이나
            의학적 소견을 제공하지 않습니다.
          </p>
        </div>

        <button
          onClick={onStart}
          className="w-full mt-3 py-4 px-6 rounded-2xl bg-primary-800 text-white font-semibold text-lg whitespace-nowrap
            active:scale-[0.98] transition-transform duration-150
            hover:bg-primary-900"
        >
          인지건강 체크하기
        </button>
      </div>
    </div>
  );
}